import * as React from "react";

function KanpakIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 93 25"
    >
      <defs>
        <clipPath>
          <rect width="93" height="25" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-kanpak)">
        <path
          data-name="Path 7038"
          d="M-16.225-8.976h1.43q2.376,0,2.376-2.068T-14.8-13.112h-1.43Zm0,8.976h-4.312V-16.588h6.864a5.872,5.872,0,0,1,4.279,1.452,5.462,5.462,0,0,1,1.485,4.092A5.462,5.462,0,0,1-9.394-6.952,5.872,5.872,0,0,1-13.673-5.5h-2.552ZM-3-5.676a2.622,2.622,0,0,0,.2,1.023,2.635,2.635,0,0,0,.539.825,2.42,2.42,0,0,0,.814.55,2.622,2.622,0,0,0,1.023.2,2.566,2.566,0,0,0,1-.2,2.42,2.42,0,0,0,.814-.55,2.844,2.844,0,0,0,.55-.814,2.374,2.374,0,0,0,.209-.99,2.449,2.449,0,0,0-.209-1,2.8,2.8,0,0,0-.55-.825,2.42,2.42,0,0,0-.814-.55,2.566,2.566,0,0,0-1-.2,2.622,2.622,0,0,0-1.023.2,2.42,2.42,0,0,0-.814.55,2.711,2.711,0,0,0-.539.8A2.408,2.408,0,0,0-3-5.676Zm5.016-5.61h4V0h-4V-1.254A4.178,4.178,0,0,1-1.441.352,5.607,5.607,0,0,1-3.707-.1a5.465,5.465,0,0,1-1.8-1.265,5.84,5.84,0,0,1-1.2-1.914,6.544,6.544,0,0,1-.429-2.4,6.36,6.36,0,0,1,.418-2.3,5.911,5.911,0,0,1,1.166-1.9,5.5,5.5,0,0,1,1.782-1.287,5.435,5.435,0,0,1,2.288-.473,4.6,4.6,0,0,1,3.5,1.474ZM12.265-18.26V-7.216l4.18-4.07H21.9L16.247-6.072,22.231,0H16.643L12.265-4.6V0H8.283V-18.26Z"
          transform="translate(69 21)"
          fill="#14a1e0"
        />
        <path
          data-name="Path 7037"
          d="M-16.819-9.746l5.258-6.842h5.324l-6.578,7.854L-5.621,0h-5.588l-5.61-7.194V0h-4.312V-16.588h4.312Zm15.158,4.07a2.622,2.622,0,0,0,.2,1.023,2.635,2.635,0,0,0,.539.825,2.42,2.42,0,0,0,.814.55,2.622,2.622,0,0,0,1.023.2,2.566,2.566,0,0,0,1-.2,2.42,2.42,0,0,0,.814-.55,2.844,2.844,0,0,0,.55-.814,2.374,2.374,0,0,0,.209-.99,2.449,2.449,0,0,0-.209-1,2.8,2.8,0,0,0-.55-.825,2.42,2.42,0,0,0-.814-.55,2.566,2.566,0,0,0-1-.2,2.622,2.622,0,0,0-1.023.2,2.42,2.42,0,0,0-.814.55,2.711,2.711,0,0,0-.539.8A2.408,2.408,0,0,0-1.661-5.676Zm5.016-5.61h4V0h-4V-1.254A4.178,4.178,0,0,1-.1.352,5.607,5.607,0,0,1-2.365-.1a5.465,5.465,0,0,1-1.8-1.265,5.84,5.84,0,0,1-1.2-1.914,6.544,6.544,0,0,1-.429-2.4,6.36,6.36,0,0,1,.418-2.3,5.911,5.911,0,0,1,1.166-1.9,5.5,5.5,0,0,1,1.782-1.287,5.435,5.435,0,0,1,2.288-.473,4.6,4.6,0,0,1,3.5,1.474Zm6.27,0h3.982v1.43a4.359,4.359,0,0,1,1.65-1.331,5.162,5.162,0,0,1,1.958-.341,4.892,4.892,0,0,1,2.035.385,4.058,4.058,0,0,1,1.441,1.089,3.129,3.129,0,0,1,.66,1.276,6.646,6.646,0,0,1,.176,1.606V0H17.545V-5.7a6.135,6.135,0,0,0-.121-1.353,1.676,1.676,0,0,0-.429-.825A1.509,1.509,0,0,0,16.4-8.25a2.212,2.212,0,0,0-.7-.11,1.969,1.969,0,0,0-1.551.605,2.512,2.512,0,0,0-.539,1.727V0H9.625Z"
          transform="translate(25 21)"
          fill="#989898"
        />
      </g>
    </svg>
  );
}

export default KanpakIcon;
